// extracted by mini-css-extract-plugin
export default {"top_title":"CustomerDataPayment_top_title__V4eJo","payment_info_top":"CustomerDataPayment_payment_info_top__3zJ2c"};